import { useState, useEffect } from "react";
import { buscarEtiquetaByIdService } from "../../../services/buscarEtiquetaByIdService";

export const useBuscarEtiqueta = (
  id: number | undefined | null,
  fetch: boolean
) => {
  const [etiqueta, setEtiqueta] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEtiqueta = async () => {
      if (id && fetch) {
        setIsLoading(true);
        try {
          const data = await buscarEtiquetaByIdService(id);
          console.log("Data recebida no hook useBuscarEtiqueta:", data);

          // 👇 Aqui está o ajuste
          if (data) {
            setEtiqueta(data); // Agora seta diretamente o objeto recebido
          } else {
            console.error("Nenhum dado retornado para a etiqueta.");
          }
        } catch (error) {
          console.error("Erro ao buscar Etiqueta:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchEtiqueta();
  }, [id, fetch]);

  return { etiqueta, isLoading };
};
